import React, { useState } from "react"
import { Grid, Container } from "@chakra-ui/react"
import { graphql, useStaticQuery } from "gatsby"
import Feed from "./Feed"
import Tags from "./Tags"

export function Blog() {
  const { allMdx } = useStaticQuery(graphql`
    query {
      allMdx(sort: { fields: [frontmatter___date], order: DESC }) {
        nodes {
          excerpt
          fields {
            slug
          }
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            description
            title
            tag
            image {
              childImageSharp {
                gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED)
              }
            }
          }
        }
      }
    }
  `)

  const { nodes } = allMdx

  const [activeTags, setActiveTags] = useState([])
  const [postLimit, setPostLimit] = useState(3)
  const tags = [...new Set(nodes.map(node => node.frontmatter.tag))]
  const bp = "lg"

  const showAllPosts = () => {
    setPostLimit(null)
  }

  const tagsProps = {
    setActiveTags,
    showAllPosts,
    activeTags,
    tags,
    bp,
  }

  const feedProps = {
    posts: nodes,
    showAllPosts,
    activeTags,
    postLimit,
    bp,
  }

  return (
    <Grid
      templateColumns="repeat(5, 1fr)"
      overflow="hidden"
      as={Container}
      gap={12}
    >
      <Tags {...tagsProps} />
      <Feed {...feedProps} />
    </Grid>
  )
}
